const $ = jQuery.noConflict();

'use strict';
const Counter = {

	$domCounter: $('.js-counter'),
	$domStampsTime: $('.js-stamps__time'),

	init: function() {
		this.counter();
	},

	counter: () => {
		if(Counter.$domCounter.length) {
			let seen = false;
			$(window).on('scroll', function() {
				if($(window).scrollTop() > Counter.$domCounter.offset().top - 500) {
					if(!seen) {
						$('.counter__number--hidden').fadeIn();
						Counter.$domStampsTime.each(function() {
							$(this).prop('Counter', 0).animate({
								Counter: $(this).text()
							}, {
								duration: 5000,
								easing: 'linear',
								step: function(now) {
									$(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
								},
							}
							);
						});
					}
					seen = true;
				}
			});
		}
	},
};
export default Counter;